import { Component, OnInit, ViewChild } from '@angular/core';
import { KioskStateService } from '../../services/kiosk-state.service';
import { KioskStateEnum } from '../../services/kiosk-state.enum';
import { BookingOrderService } from '../../../booking/services/booking-order.service';

@Component({
  selector: 'app-kiosk-event-product',
  templateUrl: './kiosk-event-product.component.html',
  styleUrls: ['./kiosk-event-product.component.css']
})
export class KioskEventProductComponent implements OnInit {

  constructor(
    protected bookingOrderService: BookingOrderService,
    private kioskStateService: KioskStateService,
  ) {
  }

  @ViewChild('eventConfigurator') eventConfigurator;

  ngOnInit() {
    const eventBookingCache = this.bookingOrderService.eventCache;

    this.eventConfigurator.minPersonCount = eventBookingCache.minPersonCount;
    this.eventConfigurator.maxPersonCount = eventBookingCache.maxPersonCount;
    this.eventConfigurator.personCount = eventBookingCache.personCount;
    this.eventConfigurator.child = eventBookingCache.guestOfHonor;

    this.eventConfigurator.slider.change.subscribe(
      (value: number) => {
        this.bookingOrderService.eventCache.personCount = value;
      }
    );
  }

  onBackwardClick() {
    this.kioskStateService.update(KioskStateEnum.Birthday);
  }

  onForwardClick() {
    const eventBookingCache = this.bookingOrderService.eventCache;
    eventBookingCache.personCount = this.eventConfigurator.slider.value;

    if (this.bookingOrderService.isAdditionalProductsExist) {
      this.kioskStateService.update(KioskStateEnum.SelectBookingExtraProducts);
    } else {
      this.kioskStateService.update(KioskStateEnum.LoginOrRegister);
    }
  }

  get forwardError(): string {
    return this.bookingOrderService.eventCache.invalidReason;
  }
}
